import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
import { CiCircleCheck } from "react-icons/ci";
import Loader from "../Loader";
import { useSendResetPasswordRequestMutation } from "../../slices/usersApiSlices";

const ForgotPasswordModal = (props) => {
  const [email, setEmail] = useState("");
  const [reqSent, setReqSent] = useState(false);

  const [sendRequest, { isLoading, error }] = useSendResetPasswordRequestMutation();

  useEffect(() => {
    if (!props.show) {
      setEmail("");
      setReqSent(false);
    }
  }, [props.show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await sendRequest({ email });
    setReqSent(true);
  };

  return (
    <Modal
      show={props.show}
      onHide={() => {
        setReqSent(false);
        props.onHide();
      }}
      centered
      contentClassName="bg-dark text-white border border-secondary"
    >
      <Modal.Header closeButton closeVariant="white" className="border-secondary">
        <Modal.Title>Forgot Password?</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-white">
        <div className="auth-panel bg-transparent border-0 shadow-none p-0">
          <p className="auth-subtitle mb-4">
            Enter your email and we will send you a link to reset your password.
          </p>

          {isLoading && <Loader />}

          {reqSent ? (
            error ? (
              <Alert className="app-empty-state app-empty-state--danger mb-0">
                {error?.data?.message || error?.error || "Could not send reset link."}
              </Alert>
            ) : (
              <div className="d-flex flex-column align-items-center text-center">
                <p className="auth-verify-message mb-2">Request sent.</p>
                <CiCircleCheck color="#22c55e" size="3.5rem" />
                <p className="text-white-50 mt-3 mb-0">
                  If an account with those details exists, a password reset link will be sent to that email address.
                </p>
              </div>
            )
          ) : (
            <Form autoComplete="off" onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  value={email}
                  type="email"
                  required
                  placeholder="Enter email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <Button
                size="sm"
                type="submit"
                variant="warning"
                className="text-dark fw-semibold"
              >
                Request Password Reset
              </Button>
            </Form>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotPasswordModal;
